import React, { useState } from 'react'
import { Card, Select, Space } from 'antd'
import { useParams } from 'react-router'
import HumanReviewProgressChart from './HumanReviewProgressChart'
import HumanReviewProgressByReviewerChart from './HumanReviewProgressByReviewerChart'
import { QuestionCircleOutlined, UserOutlined } from '@ant-design/icons'

const HumanReviewProgressCard = () => {
    const { token } = useParams()
    const [viewType, setViewType] = useState('question')

    return (
        <Card 
            title='Human review progress'
            extra={
                <Select
                    value={viewType}
                    onChange={setViewType}
                    style={{ width: 'fit-content' }}
                    options={[
                        { 
                            value: 'question', 
                            label: (
                                <Space>
                                    <QuestionCircleOutlined />
                                    By Question
                                </Space>
                            )
                        },
                        { 
                            value: 'reviewer', 
                            label: (
                                <Space>
                                    <UserOutlined />
                                    By Reviewer
                                </Space>
                            )
                        }
                    ]}
                    popupMatchSelectWidth={false}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                />
            }
        >
            {viewType === 'question' ? (
                <HumanReviewProgressChart token={token} />
            ) : (
                <HumanReviewProgressByReviewerChart token={token} />
            )}
        </Card>
    )
}

export default HumanReviewProgressCard
